import { useState, useEffect } from 'react'
import { featureFlagsApi, IFeatureFlags } from '../api/featureFlagsApi'

interface UseFeatureFlagsReturn {
  featureFlags: IFeatureFlags | null
  loading: boolean
  error: string | null
}

export const useFeatureFlags = (): UseFeatureFlagsReturn => {
  const [featureFlags, setFeatureFlags] = useState<IFeatureFlags | null>({
    budget_module_enabled: true,
    department_api_enabled: true,
    enable_budget_module: true,
    enable_restricted_access_mode: false,
    restricted_features: {}
  })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchFeatureFlags = async () => {
      try {
        setLoading(true)
        setError(null)
        const flags = await featureFlagsApi.getFeatureFlags()
        setFeatureFlags(flags)
      } catch (err) {
        console.error('Failed to fetch feature flags:', err)
        setError('Failed to load feature flags')
        // Set default values if API fails
        setFeatureFlags({
          budget_module_enabled: true,
          department_api_enabled: true,
          enable_budget_module: true,
          enable_restricted_access_mode: false,
          restricted_features: {}
        })
      } finally {
        setLoading(false)
      }
    }

    fetchFeatureFlags()
  }, [])

  return { featureFlags, loading, error }
} 